module.exports = __webpack_public_path__ + "static/img/PayCenterLogo.4dbdbfcf.svg";